import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}about/`;

export default [
    {
        type: "Paragraph",
        title: "About",
        text: "The Holy Road is een webdocumentaire over de heiligste en meest omstreden weg ter wereld: route 60, door de door Israël bezette Westelijke Jordaanoever. Reis samen met journalist Derk Walters en fotograaf Dirk-Jan Visser van zuid naar noord; langs wachttorens en checkpoints, nederzettingen en vluchtelingenkampen, en duik in de verhalen van verschillende mensen die in dit omstreden gebied leven. Hoe ziet de bezetting eruit? Wat merk je van de voortdurende strijd en de restricties? Maar vooral: hoe leven mensen hier?"
    },
    {
        type: "Paragraph",
        text: "The Holy Road is een productie van Prospektor."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}DerkWalters-EdmeeVanRijn-DirkJanVisser__mobile.jpg`,
            tablet: `${imageFolder}DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg`,
            desktop: `${imageFolder}DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg`,
            text: "Derk Walters, Edmée van Rijn en Dirk-Jan Visser"
        }
    },
    {
        type: "Quote",
        quote: "“Al langer frustreert het me dat de bezetting in individuele krantenartikelen zo lastig te beschrijven is, deels ook doordat Israël er bewust een ondoordringbare, bureaucratische situatie van heeft gemaakt. Met deze interactieve productie willen we mensen laten ervaren wat de bezetting inhoudt, zowel voor Palestijnen als voor Joodse kolonisten.”"
    },
    {
        type: "Paragraph",
        title: "Research",
        text: "Dirk-Jan Visser, Derk Walters"
    },
    {
        type: "Paragraph",
        title: "Camera & fotografie",
        text: "Dirk-Jan Visser, Edmée van Rijn"
    },
    {
        type: "Paragraph",
        title: "Teksten",
        text: "Derk Walters"
    },
    {
        type: "Paragraph",
        title: "Tolk / vertalingen",
        text: "Dvora Friedman, Hussam Taha, Riam Némmire, Edmée van Rijn"
    },
    {
        type: "Paragraph",
        title: "Online concept",
        text: "Dirk-Jan Visser, Eefje Blankevoort, Martijn van Tol, Hamid Sallali"
    },
    {
        type: "Paragraph",
        title: "Online regie en eindredactie",
        text: "Eefje Blankevoort (Prospektor)"
    },
    {
        type: "Paragraph",
        title: "Montage video's",
        text: "Eefje Blankevoort (Prospektor)"
    },
    {
        type: "Paragraph",
        title: "Vormgeving",
        text: "Hamid Sallali"
    },
    {
        type: "Paragraph",
        title: "Development",
        text: "Vincent Kranendonk (Studio Rabota), Joost Baaij (Scrollytelling)"
    },
    {
        type: "Paragraph",
        title: "Muziek",
        text: "Oliver Lyu"
    },
    {
        type: "Paragraph",
        title: "Audio correctie",
        text: "Björn Warning"
    },
    {
        type: "Paragraph",
        title: "Productie",
        text: "Edmée van Rijn in Israël en de bezette Westelijke Jordaanoever, Laura Verduijn voor Prospektor"
    },
    {
        type: "Paragraph",
        text: "©Prospektor"
    },
    {
        type: "Paragraph",
        title: "Achtergrond",
        text: "De Israëlische bezetting van de Westelijke Jordaanoever duurt in juni 2017 een halve eeuw. Een einde is allerminst in zicht: nog altijd worden de illegale Joodse nederzettingen uitgebreid, dit jaar zelfs in een verhoogd tempo. Ook al beschouwt de Israëlische regering de nederzettingen niet als een obstakel voor vrede, de Palestijnen op de Westelijke Jordaanoever lijden onder toenemende restricties. In The Holy Road onderzoeken wij hoe het dagelijks leven na vijftig jaar militaire overheersing op de Westelijke Jordaanoever eruitziet – zowel voor Palestijnen als voor Joodse kolonisten."
    },
    {
        type: "Paragraph",
        title: "Met dank aan",
        text: "The Holy Road is mede mogelijk gemaakt door een financiële bijdrage van verschillende private donoren en de Stichting Internationale Informatie en Communicatie (IIC)."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}logos__mobile.jpg`,
            tablet: `${imageFolder}logos.jpg`,
            desktop: `${imageFolder}logos.jpg`
        }
    },
]



// WEBPACK FOOTER //
// ./src/data/nl/about.js